import { render } from "./Projects.vue?vue&type=template&id=43fa5169&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=43fa5169&lang=scss&scoped=true"

import exportComponent from "/Users/casey/Documents/Development/visualspace_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fa5169"]])

export default __exports__